export default {
      id: "188,4_cm_=_70_+_45_+_70-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#188,4_cm_=_70_+_45_+_70",
      toString: function () {
        return this.url;
      }
    }